import api from "./api";

export default class RoomApi {
  static async Get() {
    return await api.get(`room`);
  }
  static async GetByAccomodation(accomodationId) {
    return await api.get(`room?accomodationId=${accomodationId}`);
  }
  static async Post(data) {
    return await api.post(`room`, data, "", {
      "Content-Type": "multipart/form-data",
    });
  }
  static async Patch(id, data) {
    return await api.patch(`room/${id}`, data, "", {
      "Content-Type": "multipart/form-data",
    });
  }
  static async Del(id) {
    return await api.del(`room/${id}`);
  }
}
